// ziven-geewen-site forum entry
// 注册 /geewen 与 /geewen/:slug 路由 → 渲染 GeeWenPage / GeewenProductPage
//
// ⚠️ 相对 import 的「本地名」必须和「路径里的文件名」完全一致 (含大小写)。
//   macOS 的文件系统默认不区分大小写 ⇒ 大小写写错时 webpack 依然能解析到文件,
//   但会**不建立绑定** ⇒ 运行时 ReferenceError, 症状是「页面整块没渲染」, 极难查。
//   写完 import 请跑 `npm run check` 兜底 (见 js/check-imports.js)。
import app from 'flarum/forum/app';
import GeewenPage from './components/GeewenPage';
import GeewenProductPage from './components/GeewenProductPage';
app.initializers.add('ziven-geewen-site', () => {
  app.routes['geewen.site'] = {
    path: '/geewen',
    component: GeewenPage
  };

  // 产品详情页 (mithril 2 的路径参数语法是 :slug)
  app.routes['geewen.product'] = {
    path: '/geewen/:slug',
    component: GeewenProductPage
  };
});